import { onFbUserChanged } from 'internal/firebase';

import type { Datastore } from './datastore';
import { logEventAsync } from './eventlog';

let appStartTime = Date.now();
const recorded: Record<string, boolean> = {};

export function recordAppStart() {
    appStartTime = Date.now();
}

export function getAppStartTime() {
    return appStartTime;
}

export function markPoint(datastore: Datastore | null, name: string) {
    if (!recorded[name]) {
        recorded[name] = true;
        const diff = Date.now() - appStartTime;
        logEventAsync(datastore, 'perf-' + name, { ms: diff });
    }
}

export function markSidebarStart(datastore: Datastore | null, sidebarStartTime: number) {
    if (!recorded['sidebar-start']) {
        recorded['sidebar-start'] = true;
        const diff = appStartTime - sidebarStartTime;
        logEventAsync(datastore, 'perf-sidebar-start', { ms: diff });
    }
}

export function _resetForTest() {
    Object.keys(recorded).forEach((key) => delete recorded[key]);
}

onFbUserChanged((user) => {
    markPoint(null, 'auth-known');
    if (user) {
        markPoint(null, 'auth-user');
    }
});

if (typeof window !== 'undefined') {
    window.addEventListener('message', (event) => {
        if (event?.data?.type === 'psi-sidebar-start-time') {
            markSidebarStart(null, event.data.startTime);
        }
    });
}
